import PropTypes from 'prop-types';

export const mapOptionPropTypes = {
  fullscreenControl: PropTypes.bool,
  fullscreenControlOptions: PropTypes.object,
  mapTypeControl: PropTypes.bool,
  mapTypeControlOptions: PropTypes.object,
  maxZoom: PropTypes.number,
  rotateControl: PropTypes.bool,
  rotateControlOptions: PropTypes.object,
  scaleControl: PropTypes.bool,
  scaleControlOptions: PropTypes.object,
  streetViewControl: PropTypes.bool,
  streetViewControlOptions: PropTypes.object,
  zoomControl: PropTypes.bool,
  zoomControlOptions: PropTypes.object
};

export const markerEvents = ['click', 'mouseover', 'mouseout'];

// MarkerClustererPlus expects legacy google.maps.Marker methods that
// AdvancedMarkerElement doesn't expose. setMap is kept by Google's legacy-
// compat layer (and shimming it recurses via the `map` property setter), so
// we only shim the read-only legacy getters here.
export const decorateAdvancedMarkerForClusterer = (marker) => {
  marker.getPosition = function () {
    const pos = this.position;
    if (pos == null) return null;
    if (typeof pos.lat === 'function') return pos;
    return new google.maps.LatLng(pos.lat, pos.lng);
  };
  marker.getDraggable = function () {
    return !!this.gmpDraggable;
  };
  marker.getVisible = function () {
    return this.map != null;
  };
  marker.getMap = function () {
    return this.map;
  };
  return marker;
};

// AdvancedMarkerElement dispatches its click via the `gmp-click` event (the
// plain `click` listener is deprecated and emits a console warning). Hover
// events aren't dispatched through addListener at all and must be attached as
// DOM listeners on the marker's content (or the marker element itself when no
// custom content is set).
export const addAdvancedMarkerEventListener = (marker, event, handler) => {
  if (event === 'click') {
    marker.addListener('gmp-click', handler);
    return;
  }
  const target = marker.content || marker.element || marker;
  target.addEventListener(event, handler);
};
export const mapStyles = {
  container: {
    position: 'absolute',
    width: '100%',
    height: '100%'
  },
  map: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0
  }
};
